import * as React from "react";
import type { SVGProps } from "react";
const SvgYoutube = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#youtube_svg__a)">
      <path d="M17 20H7a5 5 0 0 1-5-5V9a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5v6a5 5 0 0 1-5 5M7 6a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3z" />
      <path d="M10 16a1 1 0 0 1-.863-.496A1 1 0 0 1 9 15V9a1 1 0 0 1 1.51-.86l5 3a1 1 0 0 1 0 1.72l-5 3A1 1 0 0 1 10 16m1-5.23v2.46L13.06 12z" />
    </g>
    <defs>
      <clipPath id="youtube_svg__a">
        <path fill="#fff" d="M2 4h20v16H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgYoutube;
